export default __webpack_public_path__ + "static/media/offer-1.db79c663.jpg";